enum ContentProtectionModal {
  Desc = 'Asset(s) included in this request fall outside of the default approved window for Screeners.com. Please complete the Content Protection Form for later review.',
  Heading = 'Content Protection Form'
}

export {ContentProtectionModal}
